module.exports = function getResource(label, vars = []) {
    let resources = {
        relatedContentLabel: 'Related Content:'
    };
    return resources[label];
};
